<div class="audio-levels-content">

  <!-- Pair -->
  @for (pair of audioPairs; track $index; let index = $index) {
    <div class="audio-pair" (click)="select(index)">
      <!-- Levels -->
      <div class="audio-levels">
        <!-- Bar -->
        @for (channel of pair; track $index) {
          <div #level class="level">
            @for (item of levelItems; track $index; let indexLevel = $index) {
              <div
                class="item"
                [class.yellow]="indexLevel > 17 && indexLevel < 20"
                [class.orange]="indexLevel > 19 && indexLevel < 22"
                [class.red]="indexLevel > 21"
              ></div>
            }
          </div>
        }
        <!-- Selected -->
        @if (index === selected) {
          <div class="pair-selected">
            <div class="top-left"></div>
            <div class="top-right"></div>
            <div class="bottom-left"></div>
            <div class="bottom-right"></div>
          </div>
        }
      </div>
      <!-- Audio route -->
      <div class="audio-route">
        @for (channel of pair; track $index) {
          <div class="channel">{{ channel?.title }}</div>
        }
      </div>
    </div>
  }

</div>
